module.exports = __webpack_public_path__ + "img/rbcn_pro_show_4_h.da33c326.jpg";